import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router-dom'
import Fund from './fundPage'
import FundLayout from 'layout/fund/FundLayout'
import AdminDashboardLayout from 'layout/fund/AdminDashboardLayout'
import FlowReplayLayout from 'layout/fund/FlowReplayLayout'
import DotsLoading from 'components/loadings/dotsLoading'
import BulletinPage from './bulletin'
import FinancialHistory from './financialHistory'
import SettlementPage from './settlement'
import AddSettlement from './addSettlement'
import AddNewUser from './addNewUser'
import AdminSettlement from './adminSettlement'
import BuySubscription from './buySubscription'
import Commission from './commission'
import Subscription from './subscription'
import JoinUserByLink from './joinFundByLink'
import Setting from './setting'
import FinancialDashboard from './financialDashboard'
import SettingInfo from './setting/info'
import UserFundsDetail from './userFundDetails'
import ManageSetting from './setting/manage'
import UsersInformation from './setting/usersInformation'
import MemberTransparency from './setting/memberTransparency'
import MemberSMS from './setting/memberSms'
import ErrorBug from 'components/errors/bugs'
import EditInstallmentInLoan from './userFundDetails/edit'
import AnnounceToMembers from './announce'
import AnnounceDetail from './announce/detail'
import WithdrawRequestWizard from './withdrawRequest'
import WithdrawRequestDetail from './withdrawRequest/detail'
import WithdrawalRequestsPage from './withdrawalRequests'
// lazy: keeps recharts out of the main bundle
const AdminDashboard = lazy(() => import('./adminDashboard'))
// lazy: the canvas replay engine + Lalezar font stay out of the main bundle
const FlowReplay = lazy(() => import('./flowReplay'))
export const fundRoutes: RouteObject[] = [
    {
        path: '/fund',
        element: <FundLayout helmet="صندوق" />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: false,
                path: ':id',
                element: <Fund />,
            },
            {
                index: false,
                path: 'bulletin',
                element: <BulletinPage />,
            },
            {
                index: false,
                path: 'financial-history/:moneyPool/:poolship',
                element: <FinancialHistory />,
            },
            {
                index: false,
                path: 'financial-history/funds-detail/:moneyPool/:poolship/:loanId',
                element: <UserFundsDetail />,
            },
            {
                index: false,
                path: 'financial-history/funds-detail/:moneyPool/:poolship/:loanId/edit/:installmentId',
                element: <EditInstallmentInLoan />,
            },
            {
                index: false,
                path: 'settlement-exit/:moneyPool',
                element: <SettlementPage />,
            },
            {
                index: false,
                path: 'settlement-exit/add/:id',
                element: <AddSettlement />,
            },
            {
                index: false,
                path: 'add-new-user/:id',
                element: <AddNewUser />,
            },
            {
                index: false,
                path: 'join-user-by-link/:web_key',
                element: <JoinUserByLink />,
            },
            {
                index: false,
                path: 'admin-settlement-exit/:moneyPool',
                element: <AdminSettlement />,
            },
            {
                index: false,
                path: 'plans/:moneyPool',
                element: <BuySubscription />,
            },
            {
                index: false,
                path: 'plans/commission/:moneyPool',
                element: <Commission />,
            },
            {
                index: false,
                path: 'plans/subscription/:moneyPool',
                element: <Subscription />,
            },
            {
                index: false,
                path: 'financial-dashboard/:id',
                element: <FinancialDashboard />,
            },
            {
                index: false,
                path: 'setting/:id',
                element: <Setting />,
            },
            {
                index: false,
                path: 'setting/info/:id',
                element: <SettingInfo />,
            },
            {
                index: false,
                path: 'setting/users-information/:id',
                element: <UsersInformation />,
            },
            {
                index: false,
                path: 'setting/member-transparency/:id',
                element: <MemberTransparency />,
            },
            {
                index: false,
                path: 'setting/member-sms/:id',
                element: <MemberSMS />,
            },
            {
                index: false,
                path: 'setting/manage/:id',
                element: <ManageSetting />,
            },
            {
                index: false,
                path: 'announce/:id',
                element: <AnnounceToMembers />,
            },
            {
                index: false,
                path: 'announce/:id/detail/:announceId',
                element: <AnnounceDetail />,
            },
            {
                // درخواست برداشت, member side. The fund-less form is reachable
                // from home, where the member may hold capital in several
                // funds and «از کدام صندوق؟» is a real question.
                index: false,
                path: 'withdraw-request',
                element: <WithdrawRequestWizard />,
            },
            {
                index: false,
                path: 'withdraw-request/:id',
                element: <WithdrawRequestWizard />,
            },
            {
                // the SMS پیگیری link lands here, via the backend's /w/<id>/
                index: false,
                path: 'withdraw-request/detail/:id',
                element: <WithdrawRequestDetail />,
            },
            {
                // manager cartable
                index: false,
                path: 'withdrawal-requests/:id',
                element: <WithdrawalRequestsPage />,
            },
        ],
    },
    {
        // full-screen canvas replay: own minimal layout, outside the
        // FundLayout phone frame
        path: '/fund/flow-replay/:id',
        element: <FlowReplayLayout helmet="بازپخش گردش صندوق" />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                element: (
                    <Suspense fallback={<DotsLoading />}>
                        <FlowReplay />
                    </Suspense>
                ),
            },
        ],
    },
    {
        // the first desktop-responsive page: its own layout, outside the
        // FundLayout phone frame
        path: '/fund/admin-dashboard/:id',
        element: <AdminDashboardLayout helmet="داشبورد مدیریت" />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: true,
                element: (
                    <Suspense fallback={<DotsLoading />}>
                        <AdminDashboard />
                    </Suspense>
                ),
            },
        ],
    },
]
